import { units } from "@m/alchemy-theme";
export const MENU_TIMEOUT = 3000;
export const DEFAULT_MENU_WIDTH = "280px";
export const ROUGH_ITEM_HEIGHT = 34;
export const ROUGH_FOOTER_HEIGHT = 34 + units(1.5, true) + units(1, true); // taken from Button.styled and Select.styled
